import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  acceptOrRejectPayment,
  PaymentRequestReviewParams,
  PaymentReviewResponse,
  reviewPaymentRequest,
} from '../requests'
import { RequestError } from '@/common/types_and_interfaces.ts'

// Assuming the response structure
interface PaymentRequestReviewResponse {
  success: boolean
  message?: string
  // Add any other fields that are returned by your API
}

/**
 * A mutation hook for reviewing payment requests
 *
 * @param options - Optional mutation configuration options
 * @returns UseMutationResult with all tanstack query mutation properties
 */
export const useReviewPaymentRequest = (
  options?: UseMutationOptions<
    PaymentReviewResponse,
    RequestError,
    PaymentRequestReviewParams
  >
): UseMutationResult<
  PaymentReviewResponse,
  RequestError,
  PaymentRequestReviewParams
> => {
  return useMutation({
    mutationFn: reviewPaymentRequest,
    ...options,
  })
}

export const useAceptOrRejectPaymentRequest = (
  options?: UseMutationOptions<
    PaymentRequestReviewResponse,
    AxiosError,
    PaymentRequestReviewParams
  >
): UseMutationResult<
  PaymentRequestReviewResponse,
  AxiosError,
  PaymentRequestReviewParams
> => {
  return useMutation({
    mutationFn: async (params: PaymentRequestReviewParams) => {
      const { payment_id, program_id, decision, comment } = params
      const status = decision === 'accept' ? 1 : 2
      const response = await acceptOrRejectPayment(
        payment_id,
        program_id,
        status,
        comment
      )
      return response
    },
    ...options,
  })
}
